module.exports = __webpack_public_path__ + "static/MAIN_SHOW_ACT_1_CHIME-f9277fe030702e5d41e4457bf01fdefb.mp4";